// Compiled at 2026-10-07T06:21:14.844Z
// Compiled at 2026-10-07T06:21:14.844Z
// Compiled at 2026-10-07T06:21:14.844Z
// Auto-generated by Lowgile
import { MatchTransactions as Toolbox__MatchTransactions } from "../../Screen/Toolbox/MatchTransactions.js";
import { ManageMetadata as Toolbox__ManageMetadata } from "../../Screen/Toolbox/ManageMetadata.js";
import { MainLayoutSidebar as Toolbox__MainLayoutSidebar } from "../../Screen/Toolbox/MainLayoutSidebar.js";
import { MainLayoutHeader as Toolbox__MainLayoutHeader } from "../../Screen/Toolbox/MainLayoutHeader.js";
import { Login as Toolbox__Login } from "../../Screen/Toolbox/Login.js";
import { Home as Toolbox__Home } from "../../Screen/Toolbox/Home.js";
import { GoalSettingsMyTeam as Toolbox__GoalSettingsMyTeam } from "../../Screen/Toolbox/GoalSettingsMyTeam.js";
import { GoalSettingsMine as Toolbox__GoalSettingsMine } from "../../Screen/Toolbox/GoalSettingsMine.js";
import { GoalSettingsListInclude as Toolbox__GoalSettingsListInclude } from "../../Screen/Toolbox/GoalSettingsListInclude.js";
import { GoalSettingsAll as Toolbox__GoalSettingsAll } from "../../Screen/Toolbox/GoalSettingsAll.js";
import { GoalSettingView as Toolbox__GoalSettingView } from "../../Screen/Toolbox/GoalSettingView.js";
import { GoalSettingGoalsInclude as Toolbox__GoalSettingGoalsInclude } from "../../Screen/Toolbox/GoalSettingGoalsInclude.js";
import { GoalSettingGoalInclude as Toolbox__GoalSettingGoalInclude } from "../../Screen/Toolbox/GoalSettingGoalInclude.js";
import { CompanyNameLookup as Toolbox__CompanyNameLookup } from "../../Screen/Toolbox/CompanyNameLookup.js";
import { ActivityTemplate as Toolbox__ActivityTemplate } from "../../Screen/Toolbox/ActivityTemplate.js";
import { GoalSettingSelfReviewAnswersInclude as Toolbox__GoalSettingSelfReviewAnswersInclude } from "../../Screen/Toolbox/GoalSettingSelfReviewAnswersInclude.js";
import { GoalSettingViewInclude as Toolbox__GoalSettingViewInclude } from "../../Screen/Toolbox/GoalSettingViewInclude.js";
import { GoalSettingInclude as Toolbox__GoalSettingInclude } from "../../Screen/Toolbox/GoalSettingInclude.js";
import { MainLayout as Toolbox__MainLayout } from "../../Screen/Toolbox/MainLayout.js";
import { GoalSettingHome as Toolbox__GoalSettingHome } from "../../Screen/Toolbox/GoalSettingHome.js";
import { GoalSettingEdit as Toolbox__GoalSettingEdit } from "../../Screen/Toolbox/GoalSettingEdit.js";
import { GoalSettingsPerCycle as Toolbox__GoalSettingsPerCycle } from "../../Screen/Toolbox/GoalSettingsPerCycle.js";

export const Declarations = [
    Toolbox__MatchTransactions,
    Toolbox__ManageMetadata,
    Toolbox__MainLayoutSidebar,
    Toolbox__MainLayoutHeader,
    Toolbox__Login,
    Toolbox__Home,
    Toolbox__GoalSettingsMyTeam,
    Toolbox__GoalSettingsMine,
    Toolbox__GoalSettingsListInclude,
    Toolbox__GoalSettingsAll,
    Toolbox__GoalSettingView,
    Toolbox__GoalSettingGoalsInclude,
    Toolbox__GoalSettingGoalInclude,
    Toolbox__CompanyNameLookup,
    Toolbox__ActivityTemplate,
    Toolbox__GoalSettingSelfReviewAnswersInclude,
    Toolbox__GoalSettingViewInclude,
    Toolbox__GoalSettingInclude,
    Toolbox__MainLayout,
    Toolbox__GoalSettingHome,
    Toolbox__GoalSettingEdit,
    Toolbox__GoalSettingsPerCycle
];
